import { useEffect, useRef } from 'react';
import * as echarts from 'echarts';

//Создание графикоф для дашборба с echarts
const DashboardEChart = ({ option, className, isFinance, isClients }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartRef.current) {
      chartInstance.current = echarts.init(chartRef.current);
      chartInstance.current.setOption(option);
    }

    const handleResize = () => {
      if (chartInstance.current) {
        chartInstance.current.resize();
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      if (chartInstance.current) {
        chartInstance.current.dispose();
      }
    };
  }, [option]);

  return (
    <div
      ref={chartRef}
      className={className}
      style={{ width: '150%', height: isFinance ? '120%' : (isClients ? '77%' : '84%') }}
    />
  );
};

export default DashboardEChart;